import { isObject } from "@pineapplelab/util";
import { Paging } from "../paging";
import { FBase } from "./FBase";
import { IsEmail, IsNotEmpty } from "@pineapplelab/validators";
import firebase from 'firebase/compat/app';
import { DocumentReference } from "@angular/fire/firestore";
import { EmployeeStatusEnum } from "../../../app/enums/employeeState.enum";
import { IdTypeEnum } from "src/app/enums/idType.enum";


export class Employee extends FBase {
  @IsNotEmpty()
  firstName: string = '';
  @IsNotEmpty()
  lastName: string = '';
  @IsEmail()
  email: string = '';
  phoneNumber: string = '';   
  image: string = '';
  hoursWorkedWeekly: number = 0;
  state: EmployeeStatusEnum = EmployeeStatusEnum.Active;
  enterprise : Employee.IEnterprise = { email: '', dateOfBegin: null, position: '' }
  birth: Employee.IBirth = { date: null, place: '' }
  dni: Partial<Employee.IDni> = { front: null, back: null, number: null, type: null }
  page: Partial<Employee.IPage> = { role: null, image: null, description: null, show: true, priority: null }
  orderIndex: number = null;

  imageExtension: string;

  __fileImage: File;
  __dateOfBirth: Date;
  __dateOfBegin: Date;
  __dniFront: File;
  __dniBack: File;
  __pageImage: File;

  constructor(json?: { [key: string]: any }) {
    super();
    if (isObject(json)) {
      this.fromJson(json);
    }
  }
}

export namespace Employee {

  export interface IEmployee {
    id: string;
    name: string;
    lastName: string;
    dni: string;
    reference: DocumentReference
  }

  export interface IDni extends Iimage {
    front: string;
    back: string;
    number: string;
  }

  export interface Iimage {
    url: string;
    __fileImage: File;
    imageExtension: string;
    fileName: string;
    modified: boolean;
    fileSize: string;
  }

  export interface IDni extends Iimage {
    front: string;
    back: string;
    number: string;
    type: IdTypeEnum;
  }

  export interface IPage extends Iimage {
    role: string;
    image: string;
    description: string;
    show: boolean;
    priority: number;
  }

  export interface IBirth {
    date: firebase.firestore.Timestamp;
    place: string;
  }

  export interface IEnterprise {
    email: string;
    dateOfBegin: firebase.firestore.Timestamp;
    position: string;
  }

  export const PATH = 'employees';
  export const PAGING = new Paging<Employee>(<Paging.IPaging>{
    collection: PATH
  });
}